import { render, staticRenderFns } from "./chatMange.vue?vue&type=template&id=581960f8&scoped=true&"
import script from "./chatMange.vue?vue&type=script&lang=js&"
export * from "./chatMange.vue?vue&type=script&lang=js&"
import style0 from "./chatMange.vue?vue&type=style&index=0&id=581960f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581960f8",
  null
  
)

export default component.exports